import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from '@domain/models';

@Component({
  selector: 'app-report-result-message',
  imports: [CommonModule],
  templateUrl: './report-result-message.component.html',
  styleUrl: './report-result-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportResultMessageComponent {
  readonly message = input.required<Message>();

  currencyLabel(currency: string): string {
    return currency === 'PEN' ? 'S/' : `${currency} `;
  }

  numericAmount(amount: string): number {
    return Number(amount);
  }
}
